import { ContextProvider } from "../../components/Context"
import Navbar from "./Navbar"
import Table from "../../components/Table"

function CrossApp() {

    const columns = [
        { key: 'timestamp', value: 'زمان', sortable: true, upTrend: true },
        { key: 'tse_url', value: 'نماد', sortable: false, upTrend: true },
        { key: 'ppl', value: 'درصد آخرین', sortable: true, upTrend: true },
        { key: 'ind_buy_to_sell_ratio', value: 'قدرت فعلی', sortable: true, upTrend: true },
        { key: 'lowest_past_cross_value', value: 'قدرت قبلی', sortable: true, upTrend: true },
        { key: 'base_vol', value: 'ماه/مبنا', sortable: true, upTrend: false, info: true, tooltip: "نمادهای بالای 1 میتوانند حجم مبنا را پر کنند و نمادهای دارای حجم مبنای 1 باعدد 99 نشان داده شده است" },
        { key: 'ins_vol_resultant', value: 'برآیند حقوقی %', sortable: true, upTrend: false, info: true, tooltip: "برآیند حقوقی چند درصد خریدار یا فروشنده بوده است" }
    ]

    return (

        <div className="content flex-row-fluid" id="kt_content" dir="rtl">
            <div className="container-fluid mt-lg-0 mt-5">
                <ContextProvider>
                    <Navbar />

                    <div className="row ">
                        <div className="col-12 d-flex justify-content-center">
                            <div className="glass-g mb-5">
                                <div className="mb-3 text-center">
                                    <h1>ورود و خروج پول حقیقی امروز</h1>
                                </div>

                                <p className="fs-6">ورود و خروج پول درشت حقیقی امروز که باعث تغییر قدرت خریدار حقیقی میشود را در
                                    لحظه میتوانید مشاهده کنید در ضمن میتوانید برای خود سبد تعریف کرده و از خروج پول سهام
                                    موجود در سبد خود مطلع شوید</p>
                            </div>

                        </div>
                    </div>
                    <div className="row mb-5 d-lg-flex d-none">
                        <div className="col-6 d-flex justify-content-center">
                            <div>
                                <h2>بیشترین <span className="text-success">ورود</span> پول حقیقی</h2>
                            </div>
                        </div>
                        <div className="col-6 d-flex justify-content-center">
                            <div>
                                <h2>بیشترین <span className="text-danger">خروج</span> پول حقیقی</h2>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-6 d-lg-block d-none">
                            <div className="card border-16 p-3">
                                <div className=" h-100">
                                    <Table columns={columns} upTrend />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 d-lg-block d-none">
                            <div className="card border-16 p-3">
                                <div className=" h-100">
                                    <Table columns={columns} upTrend={false} />
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-12 d-lg-none d-block">
                            <div className="card border-16 p-3">
                                <div className="table-responsive">
                                    <Table columns={columns} upTrend={true} mobile={true} />
                                </div>
                            </div>
                        </div>

                    </div>
                </ContextProvider>
            </div>
        </div>
    )

}

export default CrossApp